'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function ClientComponent($http, AppConstants) {
	'ngInject';

	var service = {
		'searchClients': searchClients,
		'fetchClient': fetchClient,
		'getClient': getClient,
		'getResultSearchClients': getResultSearchClients,
		'clearResultSearchClients': clearResultSearchClients,
		'createClient': createClient,
		'updateClient': updateClient,
		'deleteClient': deleteClient
	};

	var client = {};
	var resultSearchClients = [];

	return service;

	function searchClients(value) {
		if (value.length < 1) {
			clearResultSearchClients();
		}

		return $http.get(AppConstants.apiUrl + '/clients', {
			'params': {
				'query': value,
				'page': 1,
				'per_page': AppConstants.perPage
			},
			'ignoreLoadingBar': true
		}).then(setResultSearchCities)['catch'](failedRequest);
	}

	function fetchClient(id) {
		return $http.get(AppConstants.apiUrl + '/clients/' + id).then(setCity)['catch'](failedRequest);
	}

	function setCity(response) {
		client = response.data.data;

		return client;
	}

	function setResultSearchCities(response) {
		resultSearchClients = response.data.data;

		return resultSearchClients;
	}

	function getClient() {
		return client;
	}

	function getResultSearchClients() {
		return resultSearchClients;
	}

	function clearResultSearchClients() {
		resultSearchClients = [];

		return resultSearchClients;
	}

	function createClient(params) {
		return $http.post(AppConstants.apiUrl + '/clients', params).then(successRequest)['catch'](failedRequest);
	}

	function updateClient(id, params) {
		return $http.put(AppConstants.apiUrl + '/clients/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function deleteClient(id) {
		return $http['delete'](AppConstants.apiUrl + '/clients/' + id).then(successRequest)['catch'](failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);

		return requestError;
	}
}

exports['default'] = ClientComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/client/client.service.js
 **/